import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/* Yardımcı: ay adları & gün kısaltmaları */
const monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const dayShort = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];

/* ---------------- Takvim ---------------- */
const DateRangePicker = ({ value, onChange }) => {
  const today = new Date();
  const [cursor, setCursor] = useState(new Date(today.getFullYear(), today.getMonth(), 1));
  const [range, setRange] = useState(value || { start: null, end: null });

  /* Ay ileri/geri */
  const moveMonth = (offset) =>
    setCursor((d) => new Date(d.getFullYear(), d.getMonth() + offset, 1));

  /* Gün oluşturma */
  const buildMatrix = () => {
    const firstDay = (cursor.getDay() + 6) % 7;           // Pazartesi başlat
    const daysInMonth = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
    const matrix = [];
    let day = 1 - firstDay;
    for (let r = 0; r < 6; r++) {
      const row = [];
      for (let c = 0; c < 7; c++, day++) {
        const dateObj = new Date(cursor.getFullYear(), cursor.getMonth(), day);
        row.push(dateObj);
      }
      matrix.push(row);
    }
    return matrix;
  };

  /* Tarih tıklandığında */
  const handleSelect = (date) => {
    if (date < today.setHours(0,0,0,0)) return; // geçmişe izin verme
    let newRange = { ...range };
    if (!range.start || (range.start && range.end)) {
      newRange = { start: date, end: null };
    } else if (date < range.start) {
      newRange = { start: date, end: range.start };
    } else {
      newRange.end = date;
    }
    setRange(newRange);
    if (newRange.start && newRange.end) onChange(newRange);
  };

  const matrix = buildMatrix();

  /* Tarih hücresi sınıfı */
  const cellClass = (d) => {
    const isCurrentMonth = d.getMonth() === cursor.getMonth();
    const isDisabled = d < today.setHours(0,0,0,0);
    const isSelected =
      (range.start && d.toDateString() === range.start.toDateString()) ||
      (range.end && d.toDateString() === range.end.toDateString());
    const inBetween =
      range.start && range.end && d > range.start && d < range.end;

    return [
      'w-9 h-9 flex items-center justify-center rounded-full cursor-pointer',
      isDisabled ? 'text-gray-400 pointer-events-none' : 'hover:bg-cyan-100',
      !isCurrentMonth && 'text-gray-400',
      isSelected && 'bg-cyan-600 text-white',
      inBetween && 'bg-cyan-200'
    ].filter(Boolean).join(' ');
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-lg w-72">
      {/* Başlık */}
      <div className="flex items-center justify-between mb-4">
        <button onClick={() => moveMonth(-1)} className="p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700">
          <ChevronLeft size={18}/>
        </button>
        <span className="font-semibold text-gray-800 dark:text-gray-100">
          {monthNames[cursor.getMonth()]} {cursor.getFullYear()}
        </span>
        <button onClick={() => moveMonth(1)} className="p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-700">
          <ChevronRight size={18}/>
        </button>
      </div>

      {/* Gün başlıkları */}
      <div className="grid grid-cols-7 text-xs text-center text-gray-500 dark:text-gray-400 mb-1">
        {dayShort.map(d => <span key={d}>{d}</span>)}
      </div>

      {/* Günler */}
      <div className="grid grid-cols-7 gap-1">
        {matrix.flat().map((dateObj, idx) => (
          <div key={idx} onClick={() => handleSelect(dateObj)} className={cellClass(dateObj)}>
            {dateObj.getDate()}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DateRangePicker;
